module.exports = __webpack_public_path__ + "img/proof-feedback-success.fbfc9a3c.svg";